import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormBuilder, FormGroup} from "@angular/forms";
import {Country, WidgetFilter} from "../../core/models";
import {reduce, switchMap} from "rxjs/operators";
import {from} from "rxjs/index";
import {Select} from "@ngxs/store";
import {SelectionModel} from "@angular/cdk/collections";

@Component({
  selector: 'app-filter-country-dialog',
  templateUrl: './filter-country-dialog.component.html',
  styleUrls: ['./filter-country-dialog.component.scss']
})
export class FilterCountryDialogComponent implements OnInit {

  buttonLabel: string = 'Добавить';

  form: FormGroup;
  @Select((s) => s.core.countries) countries$;
  countries = [];
  selection = new SelectionModel<Country>(true, []);

  constructor(private formBuilder: FormBuilder,
              private dialogRef: MatDialogRef<FilterCountryDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private data: WidgetFilter) {

    this.prepareOptions();

    if(data && data.val) {
      this.buttonLabel = 'Сохранить';

      if(data.type == 'country__eaes') {
        this.masterToggle('eaes');
      } else if(data.type == 'country__brics') {
        this.masterToggle('brics');
      } else {
        const counties = (data.val as string).split(';');
        for(let i=0; i<counties.length ; i++) {
          const country = this.countries.filter(v => v.name == counties[i])[0];
          this.selection.select(country);
        }
      }
    }
  }

  ngOnInit(): void {
  }

  complete() {
    let varLabel = this.varLabel;// = this.vars.filter((s: any) => s.value === this.form.value.type)[0].name;

    let payload: WidgetFilter = new WidgetFilter(
      'country__name',
      '=',
      '',
      null,
      null,
      null,
      null,
      null);
    if(this.isAllSelected('brics')) {
      payload.type = 'country__brics';
      payload.val = true;
      // varLabel = 'Все страны БРИКС';
    } else if(this.isAllSelected('eaes')) {
      payload.type = 'country__eaes';
      payload.val = true;
      // varLabel = 'Все страны ЕАЭС';
    } else {
      payload.type = 'country__name';
      payload.op = 'IN';
      payload.val = this.selection.selected.map(v => v.name).join(';');
      varLabel = `Страна = ${varLabel}`
    }
    this.dialogRef.close({data: {...payload, label: varLabel}});
  }

  declOfNum(number, titles) {
    const cases = [2, 0, 1, 1, 1, 2];
    return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
  }

  prepareOptions() {
    this.countries$
      .pipe(
        switchMap((v: Array<Country>) => from(v)
          .pipe(
            reduce( (acc, v) => acc.concat(v), []),
          )
        )
      )
      .subscribe(v => this.countries = v);
  }

  isAllSelected(type) {
    // const numSelected = this.selection.selected.length;
    // const numRows = this.countries.length;
    // return numSelected === numRows;
    let all = true;
    this.countries.forEach(row => {
      const selected = this.selection.isSelected(row);
      all = all && selected == row[type];
    });
    return all;
  }

  /** Selects all rows if they are not group selected; otherwise clear selection. */
  masterToggle(type) {
    if(this.isAllSelected(type)) {
      this.selection.clear();
    } else {
      this.selection.clear();
      this.countries.forEach(row => {
        if (row[type]) {
          this.selection.select(row)
        }
      });
    }
  }

  get varLabel(): string {
    if(this.selection.selected.length == 0) {
      return '';
    }

    if(this.isAllSelected('brics')) {
      return 'Все страны БРИКС';
    } else if(this.isAllSelected('eaes')) {
      return 'Все страны ЕАЭС';
    }

    let selected = this.selection.selected.sort((v1, v2) => v2.count - v1.count);
    const more = this.selection.selected.length - 1;
    return more ?
      `${selected[0].name} и еще ${more} ` + this.declOfNum(more, ['страна', 'страны', 'стран'])
      :
      selected[0].name;

  }

  get isValid(): boolean {
    return this.selection.selected.length > 0;
  }
}
